import Alert from "@mui/material/Alert"
import CircularProgress from "@mui/material/CircularProgress"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import UpdateMobileAppVersion from "@components/dialogs/update_mobile_app_version"
import { useMobileAppVersionPageContext } from "@contexts/main/mobile_app_version_page_context"
import type { MobileAppVersionConfig } from "@models/mobile_app_version"
import useMe from "@hooks/use_me"
import { RoleTypes } from "__generated__/graphql"

import PlatformConfigCard from "./sub_components/platform_config_card"
import VersionPreview from "./sub_components/version_preview"

export default function MobileAppVersionPage() {
  const { translate, configs, isLoading } = useMobileAppVersionPageContext()
  const { me } = useMe()
  const [editing, setEditing] = useState<MobileAppVersionConfig | null>(null)

  // Cosmetic only — the API enforces the ADMIN role on the write.
  const canEdit = me?.role === RoleTypes.Admin

  return (
    <Stack gap={2} sx={{ p: 2, width: "100%" }}>
      <Typography variant="h5">
        {translate("mobile_app_version_title")}
      </Typography>

      <Alert severity="info">{translate("mobile_app_version_page_hint")}</Alert>

      {isLoading && <CircularProgress size={24} />}

      {!isLoading && (
        <Stack direction="row" gap={2} flexWrap="wrap">
          {configs.map((config) => (
            <PlatformConfigCard
              key={config.platform}
              config={config}
              translate={translate}
              canEdit={canEdit}
              onEdit={() => setEditing(config)}
            />
          ))}
        </Stack>
      )}

      <VersionPreview translate={translate} />

      {!!editing && (
        <UpdateMobileAppVersion
          isOpen={!!editing}
          setClose={() => setEditing(null)}
          config={editing}
        />
      )}
    </Stack>
  )
}
